module.exports = __webpack_public_path__ + "media/images/iconSocialFacebook__okGreen-bdaf1e209ca74d720357fa39aecd2f4e.png";